import {
  validate as uuidValidate,
  version as uuidVersion
} from 'uuid';

export const validateUUID = (id) => {
  return uuidValidate(id) && uuidVersion(id) === 4;
};
